import { useGetAnalytics } from 'src/hooks';

export const CartAnalyticsTable = () => {
  const analyticsQuery = useGetAnalytics();

  return (
    <table className='w-full max-w-[1200px] table-auto border border-primary-dark p-6 text-base text-primary-dark sm:p-10 md:p-16 lg:p-20'>
      <thead>
        <tr className='border border-primary-dark'>
          <th className='border border-primary-dark'>Vendor</th>
          <th className='border border-primary-dark'>Cart ID</th>
          <th className='border border-primary-dark'>Date Requested</th>
          <th className='border border-primary-dark'>Requester</th>
          {/* <th>Department</th> */}
          <th className='border border-primary-dark'>Approved?</th>
          <th className='border border-primary-dark'># of Items</th>
          <th className='border border-primary-dark'>Total Cost</th>
        </tr>
      </thead>
      <tbody>
        {analyticsQuery.isPending || analyticsQuery.isLoading ? (
          <tr className='border border-primary-dark'>
            <td colSpan={7} className='h-[200px] text-center'>
              No Data to Display
            </td>
          </tr>
        ) : (
          <>
            {analyticsQuery.data?.analytics.map((analytic) => (
              <tr key={analytic.cart.id} className='border border-primary-dark'>
                <td className='whitespace-nowrap border border-primary-dark px-2'>
                  {analytic.cart.vendorDisplayName}
                </td>
                <td className='whitespace-nowrap border border-primary-dark px-2'>
                  <a
                    href={analytic.linkToCart}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-primary-dark underline transition-all hover:cursor-pointer hover:text-primary-dark/70'
                  >
                    {analytic.cart.id}
                  </a>
                </td>
                <td className='whitespace-nowrap border border-primary-dark px-2'>
                  {analytic.formattedDate}
                </td>
                <td className='flex flex-col items-start justify-center whitespace-nowrap px-2'>
                  <span className='text-primary-dark'>
                    {analytic.requestedBy.email}
                  </span>
                  <span className='text-sm text-primary-dark'>
                    {analytic.requestedBy.name}
                  </span>
                </td>
                {/* <td>{analytic.department}</td> */}
                <td className='whitespace-nowrap border border-primary-dark px-2'>
                  {analytic.cartApproved}
                </td>
                <td className='whitespace-nowrap border border-primary-dark px-2 text-end'>
                  {analytic.cart.cartTotalQty}
                </td>
                <td className='whitespace-nowrap border border-primary-dark px-2 text-end'>
                  {analytic.formattedCartPrice}
                </td>
              </tr>
            ))}
          </>
        )}
        <tr className='border-t border-primary-dark'>
          <td className='h-20 border border-primary-dark text-center font-bold'>
            TOTAL
          </td>
          <td
            colSpan={4}
            className='whitespace-nowrap border-x border-primary-dark px-2 text-end font-bold'
          >
            Carts: {analyticsQuery.data?.totalCarts || 0}
          </td>
          <td className='whitespace-nowrap border-x border-primary-dark px-2 text-end font-bold'>
            {analyticsQuery.data?.totalItems || 0}
          </td>
          <td className='whitespace-nowrap border border-primary-dark px-2 text-end font-bold'>
            {analyticsQuery.data?.totalPrice || 0}
          </td>
        </tr>
      </tbody>
    </table>
  );
};
